import React, { useState } from 'react';
import Modal from './Modal';

export default function FeedbackModal({ onClose }) {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [text, setText] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const labels = ['', 'Terrible 😤', 'Meh 😐', 'Good 😊', 'Great! 😄', 'Amazing! 🤩'];

  if (submitted) {
    return (
      <Modal title="Thanks! 🙏" onClose={onClose}>
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <div style={{ fontSize: '3rem', marginBottom: '12px' }}>🎉</div>
          <p style={{ color: '#aaa', fontSize: '0.95rem' }}>
            Your feedback means the world to us!
          </p>
          <button
            className="btn-primary"
            style={{ marginTop: '20px', fontSize: '1rem', padding: '10px 28px' }}
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </Modal>
    );
  }

  return (
    <Modal title="Rate Your Experience ⭐" onClose={onClose}>
      <div style={{ textAlign: 'center' }}>
        <p style={{ color: '#888', fontSize: '0.9rem', marginBottom: '16px' }}>
          How would you rate Resource Rush?
        </p>

        <div className="star-row">
          {[1, 2, 3, 4, 5].map(s => (
            <button
              key={s}
              className="star-btn"
              onClick={() => setRating(s)}
              onMouseEnter={() => setHover(s)}
              onMouseLeave={() => setHover(0)}
            >
              {s <= (hover || rating) ? '⭐' : '☆'}
            </button>
          ))}
        </div>

        <p style={{ color: '#FFD93D', fontFamily: 'Fredoka One', fontSize: '1.1rem', marginBottom: '16px' }}>
          {rating ? labels[rating] : 'Tap a star!'}
        </p>

        <textarea
          className="form-input"
          placeholder="Tell us more... (optional)"
          rows={3}
          value={text}
          onChange={e => setText(e.target.value)}
          style={{ resize: 'none', marginBottom: '16px' }}
        />

        <button
          className="btn-primary"
          style={{ fontSize: '1rem', padding: '10px 28px', opacity: rating ? 1 : 0.5 }}
          onClick={() => rating && setSubmitted(true)}
          disabled={!rating}
        >
          Submit Feedback
        </button>
      </div>
    </Modal>
  );
}